import React, { useState } from "react";
import { ArrowRight, Check, X } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { leadsApi } from "../../api";
import { toast } from "sonner";

const PartnerCard = ({ eyebrow, data, onApply }) => (
  <div className="card reveal" style={{ padding: "2.8rem" }}>
    <span className="eyebrow" style={{ color: "var(--muted-2)" }}>{eyebrow}</span>
    <h3 className="display" style={{ fontSize: "2rem", margin: "1rem 0 1.4rem" }}>{data.title}</h3>
    <p className="body-text" style={{ marginBottom: "1.8rem", fontSize: "0.95rem" }}>{data.desc}</p>
    <div style={{ display: "grid", gap: "0.9rem", marginBottom: "2rem", borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: "1.6rem" }}>
      {data.bullets.map((b, i) => (
        <div key={i} style={{ display: "flex", gap: "0.8rem", alignItems: "flex-start" }}>
          <span style={{ color: "var(--gold)", marginTop: 2, flexShrink: 0 }}><Check size={15} /></span>
          <span style={{ color: "var(--muted)", fontSize: "0.9rem" }}>{b}</span>
        </div>
      ))}
    </div>
    <button className="btn-outline" onClick={onApply}>{data.cta} <ArrowRight size={14} /></button>
  </div>
);

function PartnerModal({ form, onClose, initialType }) {
  const [d, setD] = useState({ name: "", email: "", phone: "", company: "", partnerType: initialType || form.types[0], message: "" });
  const submit = async () => {
    if (!d.name || !d.email) { toast.error(form.name + " & " + form.email); return; }
    try {
      await leadsApi.createPartner(d);
      toast.success(form.success);
      onClose();
    } catch (e) { toast.error(form.error); }
  };
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(6px)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1.5rem" }}>
      <div onClick={(e) => e.stopPropagation()} className="card" style={{ background: "#111015", width: "100%", maxWidth: 480, padding: "2.5rem", position: "relative", borderColor: "rgba(201,162,75,0.2)" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 18, right: 18, background: "none", border: "none", color: "var(--muted)", cursor: "pointer" }}><X size={20} /></button>
        <h3 className="display" style={{ fontSize: "1.9rem", marginBottom: "0.4rem" }}>{form.title}</h3>
        <p className="body-text" style={{ fontSize: "0.88rem", marginBottom: "1.4rem" }}>{form.subtitle}</p>
        <div style={{ display: "grid", gap: "0.9rem" }}>
          <input className="field" placeholder={form.name + " *"} value={d.name} onChange={(e) => setD({ ...d, name: e.target.value })} />
          <input className="field" placeholder={form.email + " *"} value={d.email} onChange={(e) => setD({ ...d, email: e.target.value })} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.7rem" }}>
            <input className="field" placeholder={form.phone} value={d.phone} onChange={(e) => setD({ ...d, phone: e.target.value })} />
            <input className="field" placeholder={form.company} value={d.company} onChange={(e) => setD({ ...d, company: e.target.value })} />
          </div>
          <select className="field" value={d.partnerType} onChange={(e) => setD({ ...d, partnerType: e.target.value })}>
            {form.types.map((t) => <option key={t}>{t}</option>)}
          </select>
          <textarea className="field" rows={3} placeholder={form.message} value={d.message} onChange={(e) => setD({ ...d, message: e.target.value })} />
          <button className="btn-gold" style={{ width: "100%" }} onClick={submit}>{form.submit} <ArrowRight size={14} /></button>
        </div>
      </div>
    </div>
  );
}

export default function Partners() {
  const { c } = useLang();
  const p = c.partners;
  const [modal, setModal] = useState(null); // partner type or null

  return (
    <section id="partners" className="section">
      <div className="container-x">
        <div className="reveal" style={{ maxWidth: 720, marginBottom: "3.5rem" }}>
          <span className="eyebrow">{p.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2.2rem,5vw,4rem)", margin: "1.2rem 0" }}>
            {p.title.pre}<span className="italic-gold">{p.title.em}</span>{p.title.post}
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))", gap: "1.5rem" }}>
          <PartnerCard eyebrow={p.agentsEyebrow} data={p.agents} onApply={() => setModal(p.form.types[0])} />
          <PartnerCard eyebrow={p.buildersEyebrow} data={p.builders} onApply={() => setModal(p.form.types[1])} />
        </div>
      </div>
      {modal && <PartnerModal form={p.form} initialType={modal} onClose={() => setModal(null)} />}
    </section>
  );
}
